(function () {
  'use strict';

  function init(root) {
    const track = root.querySelector('[data-nb-testi-track]');
    const dotsHost = root.querySelector('[data-nb-testi-dots]');
    if (!track || !dotsHost) return;
    const cards = Array.from(track.querySelectorAll('[data-nb-testi-card]'));
    if (cards.length < 2) return;

    // Only render dots when the track is actually scrollable (mobile/tablet).
    // On desktop the layout becomes a static grid — observe and toggle.
    function isScrollable() {
      return track.scrollWidth - track.clientWidth > 4;
    }

    function buildDots() {
      dotsHost.innerHTML = '';
      cards.forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'nb-testi__dot';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', `Go to testimonial ${i + 1}`);
        b.dataset.index = String(i);
        b.addEventListener('click', () => {
          cards[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsHost.appendChild(b);
      });
    }

    function syncActive() {
      const trackRect = track.getBoundingClientRect();
      const trackCenter = trackRect.left + trackRect.width / 2;
      let activeIndex = 0;
      let bestDist = Infinity;
      cards.forEach((card, i) => {
        const r = card.getBoundingClientRect();
        const dist = Math.abs(r.left + r.width / 2 - trackCenter);
        if (dist < bestDist) { bestDist = dist; activeIndex = i; }
      });
      Array.from(dotsHost.children).forEach((dot, i) => {
        const active = i === activeIndex;
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function refresh() {
      if (isScrollable()) {
        if (!dotsHost.children.length) buildDots();
        dotsHost.hidden = false;
        syncActive();
      } else {
        dotsHost.hidden = true;
      }
    }

    refresh();
    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(syncActive);
    }, { passive: true });
    window.addEventListener('resize', refresh);
  }

  function boot() {
    document.querySelectorAll('[data-nb-testi]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
